export enum DIALOG_TYPES {
  CREATE,
  EDIT,
  DELETE,
  LEAVE
}
